export default "__VITE_ASSET__f6ad1bb2__"